import _ from 'underscore';
import { useState, useEffect, useMemo } from 'react';

import { Asset } from '../utils/types';

export const usePaginationConfig = (assets: Array<Asset>, assetsPerPage) => {
  const [state, setState] = useState({ current: 0, total: 0 });

  useEffect(() => {
    if (!_.isEmpty(assets)) {
      setState({
        current: 1,
        total: Math.ceil(assets.length / assetsPerPage),
      });
    }
  }, [assets, assetsPerPage]);

  return useMemo(() => {
    const next = state.current + 1;
    let onNext = _.noop;
    if (next <= state.total) {
      onNext = () => setState({ ...state, current: next });
    }

    const previous = state.current - 1;
    let onPrevious = _.noop;
    if (previous > 0) {
      onPrevious = () => setState({ ...state, current: previous });
    }

    return ({
      current: state.current,
      total: state.total,
      onNext,
      onPrevious,
      resetToFirstPage: () => setState({ ...state, current: 1 }),
    });
  }, [state]);
};
